module.exports = __webpack_public_path__ + "static/SPIN-700x1080_open-account-8c64087a2b416db480de8c9544908e22.mp4";